/**
 * Generate a random string ID of length 8.
 */
export function generateRandomId(): string {
  // https://stackoverflow.com/a/19964557
  const strLength = 8;
  const decimalIndex = 2;
  const asciiRadix = 36;
  const padding = "00000000000000000";

  // Explanation:
  // 1. Pick a random number in the range [0,1), i.e. between 0 (inclusive) and 1 (exclusive).
  // 2. Convert the number to a base-36 string, i.e. using characters 0-9 and a-z.
  // 3. Pad with zeros (solves issue of number being exactly 0).
  // 4. Slice off the leading '0.' prefix and extra padding zeros.
  // 5. Repeat the string enough times to have at least "strLength" characters in it (by Joining empty strings with the shorter random string used as the delimiter).
  // 6. Slice exactly "strLength" characters from the string.
  return (Math.random().toString(asciiRadix) + padding).slice(decimalIndex, strLength + decimalIndex);
}
